import * as yup from 'yup';
import { FileUtil, FormValidationUtil } from '../../../../../utils';

export const initialValues = {
  comments: '',
  file: null,
};

export const validationSchema = yup.object().shape({
  comments: yup.string().optional(),
  file: yup
    .array()
    .optional()
    .test(
      'fileSize',
      `File size must be less than ${FileUtil.DEFAULT_ATTACHMENT_SIZE_MB}MB`,
      FormValidationUtil.validateMultipleFilesSize(
        FileUtil.DEFAULT_ATTACHMENT_SIZE_B,
      ),
    )
    .test(
      'fileFormat',
      FormValidationUtil.validateMultipleFilesFormatMessage(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
      FormValidationUtil.validateMultipleFilesFormat(
        FileUtil.DEFAULT_ALLOWED_ATTACHMENT_TYPES,
      ),
    ),
});

export const CLAIM_ATTACHMENT_TYPES = {
  CLAIM_EVIDENCE: 'Claim Evidence',
  DOC_TYPE_EXPENSE_CLAIM: 'DOC_TYPE_EXPENSE_CLAIM',
};
